export default __webpack_public_path__ + "static/media/silka-bold-webfont.5ebc9c33.eot";